// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"Filters_scroll-black__9SOGR","filters":"Filters_filters__IFnSV","filter":"Filters_filter__JN9G5","title":"Filters_title__ciGb9","options":"Filters_options__rLlq4"};